<script setup lang="ts">
interface Props {
  message: string
}

defineProps<Props>()
</script>
<template>
  <CardComponent
    v-if="message"
    bg="light"
  >
    <div class="flex flex-nowrap gap-2 items-stretch">
      <div class="w-[8px] bg-primary rounded-full" />
      <div class="text-xs">{{ message }}</div>
    </div>
  </CardComponent>
</template>
